<template>
    
    <select class="form-select" id="toggleDetectionZoneType" :value="modelValue" @change="onChange">
        <option disabled value="">{{ $t('zoneSettings.common.zoneType') }}</option>
        <option v-for="detectionzonetype in detectionzonetypes.detectionzonetypes" :key="detectionzonetype.DetectionZoneTypeId" :value="detectionzonetype.DetectionZoneTypeName">{{ zoneTypeLabel(detectionzonetype.DetectionZoneTypeName) }}</option>
    </select>
    
</template>

<script>
import { onBeforeMount } from 'vue'
import { useDetectionZoneTypeStore } from '@/stores/DetectionZoneTypeStore'
import { zoneTypeLabel } from '@/i18n/zoneTypes'

export default{
    name: 'DropdownDetectionZoneType',

    props: {
        modelValue: String
    },
    setup (props, { emit }) {
        const detectionzonetypes = useDetectionZoneTypeStore()

        onBeforeMount(() => {
            detectionzonetypes.fetchDetectionZoneTypes()
        })

        const onChange = (event) => {
            const value = event.target.value
            emit('update:modelValue', value)
            emit('detectionzonetype', value) // Emit custom event if needed
        }
        
        return {
            detectionzonetypes,
            onChange,
            zoneTypeLabel
        }
    }
}

</script>

<style scoped>

</style>